<template>
    <div id="O2">
        <customHeader :paso="paso"/>

        <section>
            <div v-if="paso == 1">
                <div>
                    <v-alert v-if="error != ''" dense outlined prominent text :type="tipoTextoIncidencia">
                        {{ error }}
                    </v-alert>

                    <div class="input-container">
                        <div class="label-input">Código de la Incidencia</div>
                      
                        <div>
                            <v-text-field id="input_o2" v-model="incidencia.codigo"  maxlength="16" tabindex="1" hide-details></v-text-field>
                        </div>
                    </div>

                        <div class="input-container">
                            <div class="label-input">Dirección de email de la Incidencia</div>
                            <div>
                                <v-text-field  id="input_o2" v-model="incidencia.mail" maxlength="60" type="email" tabindex="2" hide-details></v-text-field>
                            </div>
                        </div>

                        <div class="button-search-container">
                            <v-btn class="button-search" :loading="consultando" tabindex="3" @click="consultar">
                                <span>CONSULTAR</span>
                            </v-btn>
                        </div>
                    </div>
                </div>

                <div v-if="paso == 2">
                    <div class="info-title">Avances de la incidencia {{ incidencia.codigo }}</div>

                    <div class="info-container" v-if="hayLineas">
                        <div v-for="(item, key) in lineas" :key="key">
                            <div class="info-label">{{ getFechaFormateada(item.fecha) }}</div>
                            <div class="info-text">{{ item.linea }}</div>
                        </div>
                    </div>
                    <div v-else class="info-container">
                        <div class="info-text">
                            Aún no hay avances en la incidencia.
                        </div>
                    </div>

                    <div class="info-container more-info">
                        <span class="info-text">
                            Si tienes cualquier incidencia puedes llamar al 1551 o enviar un correo a
                        </span>
                        <span class="info-label">
                            r2r.sat@zeleris.com
                        </span>
                    </div>

                </div>
            </section>
        </div>
    </template>

    <script>
    export default {
        layout: "noZeleris",
        components: {
            customHeader: () => import("@/components/O2/customHeader"),
        },
        data: () => ({
            paso: 1,
            incidencia: {
                codigo: "",
                mail: "",
            },

            error: "",
            tipoTextoIncidencia: "",

            consultando: false,

            lineas: [],
        }),

        methods: {
            consultar() {
                this.consultando = true;
                try {
                    this.$API.getlineasPublicasEstados(this.incidencia).then((response) => {
                        if (response.codigo == 0) {
                            this.lineas = response.lineas;

                            this.paso = "2";
                        }
                    });
                } catch (error) {
                    console.log(error);
                } finally {
                    this.consultando = false;
                }
            },
            getFechaFormateada(fecha) {
                let date = new Date(fecha);
                return (
                    date.getDate().toString().padStart(2, "0") +
                    "/" +
                    (date.getMonth() + 1).toString().padStart(2, "0") +
                    "/" +
                    date.getFullYear()
                );
            },
        },
        computed: {
            hayLineas() {
                return this.lineas.length > 0;
            },
        },
    };
    </script>

    <style>
        @font-face {
            font-family: 'OnAir';
            src: url("/fonts/O2/OnAir-Black.woff2") format("woff2"), url("/fonts/O2/OnAir-Black.woff") format("woff");
            font-weight: bolder;
            font-style: normal;
        }

        @font-face {
            font-family: 'OnAir';
            src: url("/fonts/O2/OnAir-BlackItalic.woff2") format("woff2"), url("/fonts/O2/OnAir-BlackItalic.woff") format("woff");
            font-weight: bolder;
            font-style: italic;
        }

        @font-face {
            font-family: 'OnAir';
            src: url("/fonts/O2/OnAir-Bold.woff2") format("woff2"), url("/fonts/O2/OnAir-Bold.woff") format("woff");
            font-weight: bold;
            font-style: normal;
        }

        @font-face {
            font-family: 'OnAir';
            src: url("/fonts/O2/OnAir-BoldItalic.woff2") format("woff2"), url("/fonts/O2/OnAir-BoldItalic.woff") format("woff");
            font-weight: bolder;
            font-style: italic;
        }

        @font-face {
            font-family: 'OnAir';
            src: url("/fonts/O2/OnAir-Regular.woff2") format("woff2"), url("/fonts/O2/OnAir-Regular.woff") format("woff");
            font-weight: normal;
            font-style: normal;
        }

        @font-face {
            font-family: 'OnAir';
            src: url("/fonts/O2/OnAir-Italic.woff2") format("woff2"), url("/fonts/O2/OnAir-Italic.woff") format("woff");
            font-weight: normal;
            font-style: italic;
        }

        html,
        body,
        div,
        span,
        applet,
        object,
        iframe,
        h1,
        h2,
        h3,
        h4,
        h5,
        h6,
        p,
        blockquote,
        pre,
        a,
        abbr,
        acronym,
        address,
        big,
        cite,
        code,
        del,
        dfn,
        em,
        img,
        ins,
        kbd,
        q,
        s,
        samp,
        small,
        strike,
        strong,
        sub,
        sup,
        tt,
        var,
        b,
        u,
        i,
        center,
        dl,
        dt,
        dd,
        ol,
        ul,
        li,
        fieldset,
        form,
        label,
        legend,
        table,
        caption,
        tbody,
        tfoot,
        thead,
        tr,
        th,
        td,
        article,
        aside,
        canvas,
        details,
        embed,
        figure,
        figcaption,
        footer,
        header,
        hgroup,
        menu,
        nav,
        output,
        ruby,
        section,
        summary,
        time,
        mark {
            font-family: 'OnAir' !important;
        }

        #O2 section {
            min-width: 300px;
            max-width: 620px;
            margin: 0 auto;
            padding-top: 60px;
        }

        #O2 .input-container {
            margin-bottom: 40px;
        }

        #O2 .label-input {
            font-size: 16px;
            color: #212529;
            background-color: white;
            padding-bottom: 10px;
            border-radius: 30px;
        }

        #O2 .button-search-container {
            display: flex;
            justify-content: center;
            margin-top: 50px;
            margin-bottom: 70px;
        }

        #O2 .button-search {
            height: 48px;
            padding: 11px 15px;
            border-radius: 30px;
            /*background-color: #0019a5; */
            background-color: #0050FF;
            font-size: 20px;
            line-height: 1.3;
            text-align: center;
            color: #fff;
        }

        #O2 .info-title {
            margin-bottom: 50px;
            font-size: 30px;
            font-weight: 300;
            line-height: 0.93;
            color: #0019a5;
        }

        #O2 .info-container {
            margin-bottom:15px;
            text-align: justify;
        }

        #O2 .info-label {
            font-size: 15px;
            line-height: 1.67;
            color: #0090d0;
        }

        #O2 .info-text {
            font-size: 18px;
            line-height: 1.39;
            color: #5d5d5d;
        }

        #O2 .more-info {
            margin-top: 50px;
        }

        @media (max-width: 600px) {
            #O2 section {
                padding: 60px 18px;
            }
        }



        #input_o2 {
            background-color: white;
            border-radius: 15px;
            border: 1px solid grey;
            padding: 30px 10px;
        }

        #O2 .v-text-field > .v-input__control > .v-input__slot:after, .v-text-field > .v-input__control > .v-input__slot:before
         {
            bottom: -1px;
            content: "";
            left: 0;
            position: absolute;
            -webkit-transition: .3s cubic-bezier(.25, .8, .5, 1);
            transition: .3s cubic-bezier(.25, .8, .5, 1);
            width: 0%;
        }
      

    </style>
